import type { Router } from 'next/router';

export const getIsSupplierPreview = (query: Router['query']) => Boolean(query?.supplier);
